import React, { useEffect } from 'react';

function RSVP() {
  useEffect(() => {
    window.location.replace('https://www.theknot.com/us/carin-larsson-and-stephen-lau-sep-2024/rsvp')
  }, []);
  return (
    <div className="App" style={{
      width: "100%"
    }}>
    </div>
  );
}

export default RSVP;
